// VENTA
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    // Replace text for the mezcal description
    const mezcalDescriptionElement = document.querySelector(".product-text");
    if (mezcalDescriptionElement) {
      mezcalDescriptionElement.innerText = `Manojo Espadín: una expresión profunda, elegante e irresistible de agave que convertirá al principiante y asombrará al conocedor. Brillante y fresco en nariz, tiene notas de pera fresca, hierbas verdes y agua fresca. Una vez sorbido, la mineralidad es la fuerza impulsora con un paladar medio luminoso. Suave y claro, este mezcal termina fuerte y crujiente.`;
    }

    // Replace text for "Add to cart" button
    const addToCartButton = document.querySelector(".product-form__submit");
    if (addToCartButton) {
      addToCartButton.innerText = "Agregar al carrito";
    }

    // Replace text for "Buy now" button
    const buyNowButton = document.querySelector(".shopify-payment-button__button");
    if (buyNowButton) {
      buyNowButton.innerText = "Comprar";
    }
  }
});

// SHARE
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const shareButtons = document.querySelectorAll(".share-button__button");

    shareButtons.forEach(function (button) {
      const textNodes = Array.from(button.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);

      textNodes.forEach(function (textNode) {
        if (textNode.textContent.trim() === "Share") {
          textNode.textContent = "Compartir";
        }
      });
    });
  }
});

// CANTIDAD OK
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const shareButtons = document.querySelectorAll(".price-per-item__container");

    shareButtons.forEach(function (button) {
      const textNodes = Array.from(button.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);

      textNodes.forEach(function (textNode) {
        if (textNode.textContent.trim() === "Quantity") {
          textNode.textContent = "Cantidad";
        }
      });
    });
  }
});

// TRADE TITULO
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const tradeHeading = document.querySelector(".column-trade h2");
    if (tradeHeading && tradeHeading.textContent.trim() === "TRADE") {
      tradeHeading.textContent = "Comercio";
    }
  }
});

// TRADE FORM
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const nameInput = document.getElementById("mce-FNAME");
    if (nameInput) nameInput.placeholder = "NOMBRE";

    const companyInput = document.getElementById("mce-COMPANY");
    if (companyInput) companyInput.placeholder = "COMPAÑÍA";

    const phoneInput = document.getElementById("mce-PHONE");
    if (phoneInput) phoneInput.placeholder = "TELEFONO #";

    const emailInput = document.getElementById("mce-EMAIL");
    if (emailInput) emailInput.placeholder = "EMAIL";
  }
});

// TRADE BUTTONS
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  const tradeButton = document.querySelector(".trade-button");

  if (tradeButton) {
    if (locale === "es") {
      tradeButton.value = "Enviar";
    } else {
      tradeButton.value = "Submit";
    }
  }
});

// FOOTER LINKS
document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const tosLinks = document.querySelector(".tos-links");
    if (tosLinks) {
      tosLinks.innerHTML = `
        <a href="/es/pages/terminos-de-servicio">Terminos de Servicio</a> | 
        <a href="/es/pages/terminos-de-envios">Terminos de Envíos</a> | 
        <a href="/es/pages/politicas-de-privacidad">Políticas de Privacidad</a>
      `;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function getLocaleFromPath() {
    const pathLocale = window.location.pathname.split("/")[1];
    return pathLocale === "es" ? "es" : "en";
  }

  const locale = getLocaleFromPath();

  if (locale === "es") {
    const tosLinks = document.querySelector(".tos-links-mobi");
    if (tosLinks) {
      tosLinks.innerHTML = `
        <a href="/es/pages/terminos-de-servicio">Terminos de Servicio</a> | 
        <a href="/es/pages/terminos-de-envios">Terminos de Envíos</a> | 
        <a href="/es/pages/politicas-de-privacidad">Políticas de Privacidad</a>
      `;
    }
  }
});


